//  ============================================================================================================================================================
//  ===========================================================================================================================================================
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as resourcesI18 from "@Cyclope-Ui18/i18n.json";
// import * as Utils from '@Cyclope-Utils/index';
import * as i18n from "i18next";
// import * as Enums from '@tunnel-enums/index';
import * as jwt_decode from "jwt-decode";
import * as Lodash from "lodash";
import * as moment from "moment";

moment.locale("en");
// import * as fs from "fs"

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * La date du Jour ,
 * @function onDayUtils ;
 * @param {}
 * @return {string }
 */
export const onDayUtils = (): string => {
  const OptionForDayDate: any = {
    day: "numeric",
    month: "long",
    weekday: "long",
    year: "numeric",
  };
  const newDate: Date = new Date();
  let TheDay: string = newDate.toLocaleDateString("fr-FR", OptionForDayDate);
  TheDay = TheDay.charAt(0).toUpperCase() + TheDay.slice(1);
  return TheDay;
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * La date du Jour ,
 * @function limitDays ;
 * @param {}
 * @return {string }
 */
export const limitDays = (date: any, index: number): boolean => {
  const minDate: any = moment()
    .subtract("days", index)
    .format("YYYY-MM-DDTHH:mm:ss");
  return moment(date).format("YYYY-MM-DDTHH:mm:ss") >= minDate;
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Le tri des tableaux par ordre (asc ou dec)
 * @param { any } property
 * @return { string }
 */
export const dynamicSort = (property: any) => {
  let sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return (a: any, b: any) => {
    if (sortOrder === -1) {
      return b[property].localeCompare(a[property]);
    } else {
      return a[property].localeCompare(b[property]);
    }
  };
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * L'heure du Jour ,
 * @function onClockUtils
 * @param {  }
 * @return { string }
 */
export const onClockUtils = (): any => {
  const today = new Date();
  let h: any = today.getHours();
  let m: any = today.getMinutes();
  let s: any = today.getSeconds();
  h = h < 10 ? "0" + h : h;
  m = m < 10 ? "0" + m : m;
  s = s < 10 ? "0" + s : s;

  const time = h + ":" + m + ":" + s;

  return time;
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Activation de la lecture vidéo
 * @function onPlayAndPause
 * @param {}
 * @return {}
 */

export const onPlayAndPause = (): void => {
  const video: any = document.querySelector(".videoOutput");

  if (video.paused) {
    video.play();
  } else {
    video.play();
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Interchanger les sources de video
 * @function onChangeSourceVideoImpact
 * @param { any } event
 * @return { array }
 */

export const onChangeSourceAndTarget = (event: any): any => {
  const targetElement: any = document.querySelector("#largeImage");
  const SourceElement: any = event.target.parentElement;

  const target: any[] = [];
  const source: any[] = [];

  if (
    !Lodash.isEmpty(targetElement.children) ||
    !Lodash.isEmpty(SourceElement.children)
  ) {
    for (const j in targetElement.children) {
      if (targetElement.children.hasOwnProperty(j)) {
        target.push(targetElement.children[j]);
      }
    }

    for (const i in SourceElement.children) {
      if (SourceElement.children.hasOwnProperty(i)) {
        source.push(SourceElement.children[i]);
      }
    }
  }

  const targetSlice = target.slice();
  const sourceSlice = source.slice();

  return {
    sourceSlice,
    targetSlice,
  };
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Changement des sources au click de la souris
 * @function onChangeTargetIncident
 * @param { any } SourceElement
 * @param { any } targetElement
 * @param { any } changeSource
 * @return { }
 */
export const onChangeTargetIncident = (
  SourceElement: any,
  targetElement: any,
  changeSource: any
) => {
  const sourceTargetArray = [SourceElement, targetElement];

  sourceTargetArray.map((Elem) => {
    for (const key in Elem.children) {
      if (Elem.children.hasOwnProperty(key)) {
        if (Elem.children[0] !== "undefined") {
          Elem.children[0].remove();
        }
      }
    }
  });

  for (const key in changeSource.sourceSlice) {
    if (changeSource.sourceSlice.hasOwnProperty(key)) {
      targetElement.appendChild(changeSource.sourceSlice[key]);
    }
  }
  for (const key in changeSource.targetSlice) {
    if (changeSource.targetSlice.hasOwnProperty(key)) {
      SourceElement.appendChild(changeSource.targetSlice[key]);
    }
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Tranforme un object en tableau
 * @function transformObjectToArray
 * @param { object } data
 * @return { array }
 */

export const transformObjectToArray = (data: object): any => {
  if (!Lodash.isUndefined(data)) {
    const Arr: any[] = [];
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        Arr.push(data[key]);
      }
    }
    return Arr;
  }
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Date au format France
 * @function localDateFrenchFormat
 * @param { number } year,
 * @param { number } months,
 * @param { number } day,
 * @param { number } dayOfMonth,
 * @param { number } hours,
 * @param { number } minutes,
 * @param { number } year,
 * @return { string }
 */

export const localDateFrenchFormat = (
  year: number,
  months: number,
  day: number,
  dayOfMonth: number,
  hours: number,
  minutes: number
): any => {
  // const mois_fr = [
  //   "jan",
  //   "fév",
  //   "mar",
  //   "avr",
  //   "mai",
  //   "jun",
  //   "jul",
  //   "aoû",
  //   "sep",
  //   "oct",
  //   "nov",
  //   "déc",
  // ];

  const mois = [
    "jan",
    "feb",
    "mar",
    "apr",
    "mai",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];

  let message = dayOfMonth + " ";
  message += mois[months] + " ";
  message += year + " ";

  const h = hours < 10 ? "0" + hours : hours;
  const m = minutes < 10 ? "0" + minutes : minutes;

  message += h + ":";
  message += m + " ";

  return message;
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * @function localDateFrenchSecondFormat
 * @param year
 * @param months
 * @param day
 * @param dayOfMonth
 * @param hours
 * @param minutes
 * @return { string }
 */
export const localDateFrenchSecondFormat = (
  year: number,
  months: number,
  day: number,
  dayOfMonth: number,
  hours: number,
  minutes: number
): any => {
  const month = months < 10 ? "0" + months : months;
  const dayof = dayOfMonth < 10 ? "0" + dayOfMonth : dayOfMonth;
  let message = dayof + "/";
  message += month + "/";
  message += year + " ";

  const h = hours < 10 ? "0" + hours : hours;
  const m = minutes < 10 ? "0" + minutes : minutes;

  message += h + ":";
  message += m + " ";

  return message;
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * La date au format Français
 * @function localDateFrFormat
 * @param { any } date
 * @return { string }
 */
export const localDateFrFormat = (date: any): any => {
  const FormatDate = new Date(date);
  const year = FormatDate.getFullYear();
  const month = FormatDate.getMonth();
  const dayOfMonth = FormatDate.getDate();
  const hours = FormatDate.getHours();
  const minutes = FormatDate.getMinutes();
  const secondes = FormatDate.getSeconds();

  const months = [
    "Jan",
    "Fév",
    "Mar",
    "Avr",
    "Mai",
    "Jun",
    "Jul",
    "Aoû",
    "Sep",
    "Oct",
    "Nov",
    "Déc",
  ];

  let message = dayOfMonth + " ";
  message += months[month] + " ";
  message += year + " ";

  const h = hours < 10 ? "0" + hours : hours;
  const m = minutes < 10 ? "0" + minutes : minutes;
  const s = secondes < 10 ? "0" + secondes : secondes;

  message += " - ";
  message += h + ":";
  message += m + ":";
  message += s + " ";

  return message;
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * La date au format Français
 * @function localDateFrFormat
 * @param { any } date
 * @return { string }
 */
export const localDateFrFormatMessage = (date: any): any => {
  const FormatDate = new Date(date);
  const year = FormatDate.getFullYear();
  const month = FormatDate.getMonth();
  const dayOfMonth = FormatDate.getDate();
  const hours = FormatDate.getHours();
  const minutes = FormatDate.getMinutes();
  const secondes = FormatDate.getSeconds();

  // const months_fr= [
  //   "Jan",
  //   "Fév",
  //   "Mar",
  //   "Avr",
  //   "Mai",
  //   "Jun",
  //   "Jul",
  //   "Aoû",
  //   "Sep",
  //   "Oct",
  //   "Nov",
  //   "Déc",
  // ];

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  let message = dayOfMonth + " ";
  message += months[month] + " ";
  message += year + " ";

  const h = hours < 10 ? "0" + hours : hours;
  const m = minutes < 10 ? "0" + minutes : minutes;
  const s = secondes < 10 ? "0" + secondes : secondes;

  message += " - ";
  message += h + "h: ";
  message += m + "min: ";
  message += s + " ";

  return message;
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * La date au format Français
 * @function localDateFrSecondFormat
 * @param {any } date
 * @return { string }
 */
export const localDateFrSecondFormat = (date: any): any => {
  const FormatDate = new Date(date);
  const year = FormatDate.getFullYear();
  const monthof = FormatDate.getMonth() + 1;
  const month = monthof < 10 ? "0" + monthof : monthof;
  const dayOfMonth = FormatDate.getDate();
  const dayof = dayOfMonth < 10 ? "0" + dayOfMonth : dayOfMonth;
  const hours = FormatDate.getHours();
  const minutes = FormatDate.getMinutes();
  const secondes = FormatDate.getSeconds();

  let message = dayof + "/";
  message += month + "/";
  message += year + " ";

  const h = hours < 10 ? "0" + hours : hours;
  const m = minutes < 10 ? "0" + minutes : minutes;
  const s = secondes < 10 ? "0" + secondes : secondes;

  message += h + ":";
  message += m + ":";
  message += s;

  return message;
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Overture de la popup d'information " datails de la caméra"
 * @function onOpenCameraInformation
 * @param {}
 * @return {}
 */
export const onOpenCameraInformation = (): void => {
  const modalCameraInformation: any = document.querySelector("#camera-details");

  if (modalCameraInformation !== null) {
    modalCameraInformation.style.display = "block";
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Ferméture de la popup d'information " datails de la caméra"
 * @function onCloseCameraInformation
 * @param {}
 * @return {}
 */
export const onCloseCameraInformation = (): void => {
  const modalCameraInformation: any = document.querySelector("#camera-details");

  if (modalCameraInformation !== null) {
    modalCameraInformation.style.display = "none";
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Ferméture de la popup de la création d'inhibition
 * @function onCloseInhibition
 * @param {}
 * @return {}
 */
export const onCloseInhibition = (): void => {
  const modalCameraInformation: any = document.querySelector(
    "#modal-inhibition"
  );

  if (modalCameraInformation !== null) {
    modalCameraInformation.style.display = "none";
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Ouverture de la popup de la création d'inhibition
 * @function onOpenInhibition
 * @param {}
 * @return {}
 */
export const onOpenInhibition = (): void => {
  const modalCameraInformation: any = document.querySelector(
    "#modal-inhibition"
  );

  if (modalCameraInformation !== null) {
    modalCameraInformation.style.display = "block";
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Onglet de la liste des incidents :
 * parametrage de la camera
 * @function  cameraSettingTitle
 * @param {}
 * @return { string }
 */
export const cameraSettingTitle = (): string[] => {
  const Title: string[] = [];

  Title.push(
    "Véhicule arrêté",
    "Véhicule lent",
    "Congestion",
    "Piéton",
    "Feu ",
    "Fumée",
    "Contresens"
  );

  return Title;
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Onglet entête de la page incident
 * @function sectionSeting
 * @param {}
 * @return { string }
 */
export const sectionSetting = (): string[] => {
  const Sections: string[] = [];

  Sections.push(
    "Tous les tubes",
    "Tube nord",
    "Tube sud",
    "Intertube",
    "Trémie Léon Bourgeois"
  );

  return Sections;
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * elle vérifie la présence d'un utilisateur authentifier
 * @function isAuthenticated
 * @param { any } user - user est l'utilisateur actuellement connecter
 * @return { boolean }
 */
export const isAuthenticated = (user: any): boolean => !!user;

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Definit les authorisations attribuée à un utilisateur
 * Certaines page ou fonctionnalités sont limité
 * @function simpleAuthorizationIsAllowed
 * @param { any } user
 * @param { array<string>} rights
 * @return { any }
 */

export const simpleAuthorizationIsAllowed = (
  user: any,
  rights: string[]
): any =>
  rights &&
  user &&
  rights.some((right) => user.rights && user.rights.includes(right));

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Définit le rôle et les actions de l'utilisateur
 * @function simpleAuthorizationHasRole
 * @param { any } user
 * @param { array<string>} roles
 * @return { any }
 */

export const simpleAuthorizationHasRole = (user: any, roles: string[]): any =>
  roles &&
  user &&
  roles.some((role) => user.roles && user.roles.includes(role));

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Attribution des authorizations aux utilisateurs
 * @function createdUserRoles
 * @param {}
 * @return { any }
 */
export const createdUserRoles = (): any => {
  if (
    localStorage.getItem("authorization") &&
    localStorage.getItem("authorization") !== null
  ) {
    const AUTHORISATION: any = localStorage.getItem("authorization");

    if (AUTHORISATION) {
      const user = {
        rights: [""],
        roles: [""],
      };
      const data: any =
        localStorageIsKeyExist() && jwt_decode(localStorageIsKeyExist());

      const Token = data && data.auth && data.auth.split(",");
      if (Token !== null && Token) {
        Promise.all(
          Token.map((elem: any) => {
            user.roles.push(elem);

            switch (elem) {
              default:
                AUTHORISATION.split(",").map((authorisation: any) =>
                  user.rights.push(authorisation)
                );

                break;
            }
          })
        );
      }

      return user;
    }
  } else {
    return localStorageClear();
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Association de rôle et droit
 * @function simpleAuthorizationAddRights
 * @param user
 * @param actions
 */
export const simpleAuthorizationAddRights = (user: any, actions: string[]) =>
  actions.map((action) => user.rights.push(action));

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Création d'une clé ,stocké chez le client
 * @function localStorageSetItem
 * @param { any} Token
 * @return {void}
 */
export const localStorageSetItem = (Token: any): void => {
  const key = "tunnel_watch_auth";

  // vérification de l'existance du token
  if (!localStorage.getItem(key)) {
    localStorage.setItem(key, Token);
  } else {
    if (verifIsTokenIsValidOrExpired()) {
      localStorage.setItem(key, Token); // creation du token
    } else {
      localStorage.removeItem(key); // suppression du token
      localStorage.setItem(key, Token); // creation du token
    }
  }

  // return !localStorage.getItem(key) && localStorage.setItem(key, Token);
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Destruction des clés
 * stockées chez le client
 * @function localStorageItem
 * @param {}
 * @return {}
 */
export const localStorageClear = (): void => {
  const key = "tunnel_watch_auth";

  localStorage.removeItem(key);
  localStorage.removeItem("menuactive");
  localStorage.removeItem("submenuactive");
  localStorage.removeItem("currentPage");
  localStorage.removeItem("itemPerPage");
  localStorage.removeItem("currentPageIncident");
  localStorage.removeItem("itemPerPageIncident");
  localStorage.removeItem("pageVisibleIncident");
  localStorage.removeItem("pageVisible");
  localStorage.removeItem("pageVisibleIncident");
  localStorage.removeItem("sorting");
  localStorage.removeItem("sortingCitilog");
  localStorage.removeItem("pageVisibleCitilog");
  localStorage.removeItem("initialisationCitilog");
  localStorage.removeItem("menu");
  localStorage.removeItem("columns");
  localStorage.removeItem("currentPageCitilog");
  localStorage.removeItem("initialisationIncident");
  localStorage.removeItem("subMenuActiveAdministrator");
  localStorage.removeItem("subMenuActiveSupervisor");
  localStorage.removeItem("notification");
  localStorage.removeItem("authorization");
  localStorage.removeItem("fluxparam");
  localStorage.removeItem("incidentnotifications");
  localStorage.removeItem("tmdnumbersincident");
  localStorage.removeItem("supermenu");
  localStorage.removeItem("tmdmenu");
  localStorage.removeItem("adminmenu");
  localStorage.removeItem("menus");
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Vérification de l'existence de la clé
 * @function localStorageIsKeyExist
 * @param {}
 * @return { any }
 */
export const localStorageIsKeyExist = (): any => {
  const key = "tunnel_watch_auth";

  return localStorage.getItem(key);
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Vérification de l'existence et la validité de la clé
 * @function verifIsTokenIsValidOrExpired
 * @param {}
 * @return { any }
 */
export const verifIsTokenIsValidOrExpired = (): boolean => {
  /**
   * @constant
   * @description : tableau Inhibition
   * @name  key
   * @types any[]
   */
  const key = "tunnel_watch_auth";
  /**
   * @constant
   * @description : tableau Inhibition
   * @name  token
   * @types any[]
   */
  const token: any = localStorage.getItem(key);

  // Vérification de l'existance du token
  if (!Lodash.isNull(token)) {
    /**
     * @constant
     * @description : tableau Inhibition
     * @name  jwtDecodeToken
     * @types any[]
     */
    const jwtDecodeToken: any = jwt_decode(token);
    {
      /** vérification de l'existence du token */
    }

    if (
      jwtDecodeToken &&
      typeof jwtDecodeToken === "object" &&
      jwtDecodeToken.exp
    ) {
      {
        /** affectation par décomposition de l'objet */
      }
      const { exp } = jwtDecodeToken;

      {
        /** comparer la variable */
      }
      if (exp > Date.now() / 1000) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * La traduction de l'application
 * @function initTranslations
 * @param {}
 * @return { any }
 */
export const initTranslations = (Lng: string): any => {
  return i18n.init({
    debug: false,
    defaultNS: "translations",

    fallbackLng: Lng,
    interpolation: {
      escapeValue: false, //  not needed for react!!
      formatSeparator: ",",
    },
    keySeparator: false, //  we use content as keys
    //  have a common namespace used around the full app
    ns: ["translations"],
    react: { wait: true },
    //  we init with resources
    resources: resourcesI18,
  });
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Vérification si un element existe depuis plus de 30 jours
 * @function isLessThan30Days
 * @param { any } elem
 * @return { boolean }
 */
export const isLessThan30Days = (elem: any) => {
  const today = new Date();
  return moment(today).diff(elem.startTime, "days") <= 30;
};

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Vérification si un element existe depuis plus de 30 jours
 * @function isLessThan7Days
 * @param { any } elem
 * @return { boolean }
 */
export const isLessThan7Days = (elem: any) => {
  const today = new Date();
  return moment(today).diff(elem.startTime, "days") <= 7;
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Supprimer les accents et les espace de la chaîne de caractères
 * @function removeAccentsFromString
 * @param { string } strAccents
 * @return { string }
 */
export const removeAccentsFromString = (strAccents: string) => {
  const strAccent: any = strAccents.split("");
  let strAccentsOut: any = new Array();
  const strAccentsLen: number = strAccent.length;
  const accents =
    "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
  const accentsOut =
    "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
  for (let y = 0; y < strAccentsLen; y++) {
    if (accents.indexOf(strAccents[y]) !== -1) {
      strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
    } else {
      strAccentsOut[y] = strAccents[y];
    }
  }
  strAccentsOut = strAccentsOut.join("");
  return strAccentsOut.replace(/\s/g, "_");
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Création d'un objet avec  tableau unique
 * @function createAnUniqueArrayFromCameraObject
 * @param { any } Elem
 * @param { string } string
 * @return { any }
 */
export const createAnUniqueArrayFromCameraObject = (
  Elem: any,
  action: string
): any => {
  if (
    !Lodash.isUndefined(Elem) &&
    Lodash.isArray(Elem) &&
    !Lodash.isEmpty(Elem)
  ) {
    const arr: string[] = [];

    for (let i = 0; i < Elem.length; i++) {
      switch (action) {
        case "label":
          arr[i] = Elem[i].label;
          break;

        case "camera":
          arr[i] = Elem[i].code;
          break;
        case "cameraLapi":
          arr[i] = Elem[i].codeCamera;
          break;

        case "section":
          arr[i] = Elem[i].name;
          break;
      }
    }

    return arr.filter((v: any, i: any) => arr.indexOf(v) === i);
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Fermer ou élargir le menu
 * @function hideShowmenu
 * @param {}
 * @return {}
 */
export const hideShowmenu = () => {
  const menu: any = document.querySelector("#menu");
  const main: any = document.querySelector("#main");
  const menuBurder: any = document.querySelector("#menu-burger");
  const columns: any = document.querySelector("#columns");

  if (menuBurder !== null) {
    //  left main
    const name = "left menu menuLeft";
    const nameMain = "left main mainLeft";

    if (columns !== null) {
      const columnsCLass3 = "with-3-columns";
      const columnsCLass4 = "with-4-columns";
      const columnsCLass5 = "with--columns";
      const arrColumnsCLass = columns.className.split(" ");

      if (columns.classList.contains("with-3-columns")) {
        if (arrColumnsCLass.indexOf(columnsCLass4) === -1) {
          columns.className = columnsCLass4;
        }
      } else if (columns.classList.contains("with--columns")) {
        if (arrColumnsCLass.indexOf(columnsCLass5) === -1) {
          columns.className = columnsCLass5;
        }
      } else if (columns.classList.contains("with-4-columns")) {
        if (arrColumnsCLass.indexOf(columnsCLass3) === -1) {
          columns.className = columnsCLass3;
        }
      }
    }

    const nameRight = "left menu menuRight";
    const nameMainRight = "left main mainRight";

    const arrMain = main.className.split(" ");
    const arrMenu = menu.className.split(" ");

    if (
      menu.classList.contains("menuRight") &&
      main.classList.contains("mainRight")
    ) {
      if (arrMenu.indexOf(name) === -1 && arrMain.indexOf(nameMain) === -1) {
        menu.className = name;
        main.className = nameMain;
        localStorage.setItem("menu", "menuLeft");
        localStorage.setItem("columns", "with-4-columns");
      }
    } else {
      if (
        arrMenu.indexOf(nameRight) === -1 &&
        arrMain.indexOf(nameMainRight) === -1
      ) {
        menu.className = nameRight;
        main.className = nameMainRight;
        localStorage.setItem("menu", "menuRight");
        localStorage.setItem("columns", "with-3-columns");
      }
    }
  }
};
// =======================================================================================================

/**
 * @function onFocus
 * @param { any } event
 */
export const onFocus = (event: any) => {
  event.preventDefault();

  const getSelectQuery: any = document.querySelector("#labelListOptions");

  if (getSelectQuery !== null) {
    const labelOpen = "selectedLabel labelListOpen animated slideInUp";
    const labelListClose = "selectedLabel labelListClose animated fadeOut";

    const arrayLabel = getSelectQuery.className.split(" ");

    if (getSelectQuery.classList.contains("labelListClose")) {
      if (arrayLabel.indexOf(labelListClose) === -1) {
        getSelectQuery.className = labelOpen;
      }
    }
  }
};
/**
 * @function onFocusincident
 * @param { any } event
 */
export const onFocusIncident = (event: any) => {
  event.preventDefault();

  const getIncidentSelectQuery: any = document.querySelector(
    "#labelListSelect"
  );

  if (getIncidentSelectQuery !== null) {
    const labelOpen = "selectedLabel selectOpen animated slideInUp";
    const selectClose = "selectedLabel selectClose animated fadeOut";

    const arrayLabel = getIncidentSelectQuery.className.split(" ");

    if (getIncidentSelectQuery.classList.contains("selectClose")) {
      if (arrayLabel.indexOf(selectClose) === -1) {
        getIncidentSelectQuery.className = labelOpen;
      }
    }
  }
};
// =======================================================================================================
/**
 * @function onBlur
 * @param { any } event
 */
export const onBlur = (event: any) => {
  event.preventDefault();

  const getSelectQuery: any = document.querySelector("#labelListOptions");
  const getIncidentSelectQuery: any = document.querySelector(
    "#labelListSelect"
  );

  window.setTimeout(() => {
    if (getSelectQuery !== null) {
      const labelOpen = "selectedLabel labelListOpen animated slideInUp";
      const labelListClose = "selectedLabel labelListClose animated fadeOut";

      const arrayLabel = getSelectQuery.className.split(" ");

      if (getSelectQuery.classList.contains("labelListOpen")) {
        if (arrayLabel.indexOf(labelOpen) === -1) {
          getSelectQuery.className = labelListClose;
        }
      }
    } else if (getIncidentSelectQuery !== null) {
      const labelOpen = "selectedLabel selectOpen animated slideInUp";
      const selectClose = "selectedLabel selectClose animated fadeOut";

      const arrayLabel = getIncidentSelectQuery.className.split(" ");

      if (getIncidentSelectQuery.classList.contains("selectOpen")) {
        if (arrayLabel.indexOf(labelOpen) === -1) {
          getIncidentSelectQuery.className = selectClose;
        }
      }
    }
  }, 300);
};
// =======================================================================================================

/**
 * @function onBlurIncident
 * @param { any } event
 */
export const onBlurIncident = (event: any) => {
  event.preventDefault();

  const getIncidentSelectQuery: any = document.querySelector(
    "#labelListSelect"
  );

  window.setTimeout(() => {
    if (getIncidentSelectQuery !== null) {
      const labelOpen = "selectedLabel selectOpen animated fadeIn";
      const selectClose = "selectedLabel selectClose animated fadeOut";

      const arrayLabel = getIncidentSelectQuery.className.split(" ");

      if (getIncidentSelectQuery.classList.contains("selectOpen")) {
        if (arrayLabel.indexOf(labelOpen) === -1) {
          getIncidentSelectQuery.className = selectClose;
        }
      }
    }
  }, 300);
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Fermer ou élargir le menu
 * @function persistentMenuPosition
 * @param {}
 * @return {}
 */
export const persistentMenuPosition = () => {
  const menu: any = document.querySelector("#menu");
  const main: any = document.querySelector("#main");
  const menuKey: any = localStorage.getItem("menu");

  if (menuKey !== null) {
    const name = "left menu menuLeft";
    const nameMain = "left main mainLeft";

    const nameRight = "left menu menuRight";
    const nameMainRight = "left main mainRight";

    const arrMain = main.className.split(" ");
    const arrMenu = menu.className.split(" ");

    if (menuKey === "menuLeft") {
      if (arrMenu.indexOf(name) === -1 && arrMain.indexOf(nameMain) === -1) {
        menu.className = name;
        main.className = nameMain;
      }
    } else if (menuKey === "menuRight") {
      if (
        arrMenu.indexOf(nameRight) === -1 &&
        arrMain.indexOf(nameMainRight) === -1
      ) {
        menu.className = nameRight;
        main.className = nameMainRight;
      }
    }
  }
};
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Fermer ou élargir le menu
 * @function persistentColumnPosition
 * @param { empty}
 * @return { void }
 */
export const persistentColumnPosition = (): void => {
  const columns: any = document.querySelector("#columns");
  const columnsInhibition: any = document.querySelector("#columnsInhibition");

  const columnsKey: any = localStorage.getItem("columns");

  if (columnsKey !== null) {
    if (columns !== null) {
      if (columns.classList.contains("with-3-columns")) {
        if (columnsKey === "with-3-columns") {
          columns.className = columnsKey;
        } else if (columnsKey === "with-4-columns") {
          columns.className = columnsKey;
        }
      }
    } else if (columnsInhibition !== null) {
      if (columnsInhibition.classList.contains("with-3-columns")) {
        if (columnsKey === "with-3-columns") {
          columnsInhibition.className = columnsKey;
        } else if (columnsKey === "with-4-columns") {
          columnsInhibition.className = columnsKey;
        }
      }
    }
  }
};

//  ===========================================================================================================================================================
/**
 * Cloner un objet Javascript
 * @function
 * @name cloneObjectOrArray
 * @param { any } data
 * @return { any[] }
 */
export const cloneObjectOrArray = (data: any[]): any[] =>
  Lodash.cloneDeep(data);

//  ===========================================================================================================================================================
/**
 * Customizing Line Chart
 * @function
 * @name customizingLineChart
 * @param { string } firstColor
 * @param { string } secondColor
 * @return { any }
 */
export const customizingLineChart = (
  firstColor: string,
  secondColor: string
): any => {
  const canvas: any = document.getElementById("myChart");

  if (canvas !== null) {
    const ctx: CanvasRenderingContext2D = canvas.getContext("2d");
    const gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    gradientStroke.addColorStop(0, firstColor);
    gradientStroke.addColorStop(1, secondColor);
    return gradientStroke;
  }
};

// ======================================================================================================
/**
 * Customizing Line Chart
 * @function
 * @name validatorString
 * @param { string } element
 * @return { boolean }
 */
export const validatorString = (element: string, bypassBackslash: boolean = false): boolean => {
  if (!Lodash.isUndefined(element) && !Lodash.isNull(element)) {
    const regex = !bypassBackslash
      ? /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,0-9,.,@,_'-]+$/u
      : /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\\\\ ,0-9,.,@,_'-]+$/u
      
    if (element.match(regex)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
// ======================================================================================================
/**
 * Customizing Line Chart
 * @function
 * @name validatorNumber
 * @param { string } element
 * @return { boolean }
 */
export const validatorNumber = (element: string): boolean => {
  if (!Lodash.isUndefined(element) && !Lodash.isNull(element)) {
    if (element.match(/^[0-9]+$/u)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

// ======================================================================================================
/**
 * Customizing Line Chart
 * @function
 * @name validatorIpValue
 * @param { string } element
 * @return { boolean }
 */
export const validatorIpValue = (element: string): boolean => {
  if (!Lodash.isUndefined(element) && !Lodash.isNull(element)) {
    if (
      element.match(
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      )
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

// ======================================================================================================
/**
 * Customizing Line Chart
 * @function
 * @name validatorString
 * @param { string } element
 * @return { boolean }
 */
export const getHiddenProp = (): any => {
  const prefixes: string[] = ["webkit", "moz", "ms", "o"];

  // if 'hidden' is natively supported just return it
  if ("hidden" in document) {
    return "hidden";
  }
  // otherwise loop over all the known prefixes until we find one
  for (const i of prefixes) {
    if (prefixes[i] + "Hidden" in document) {
      return prefixes[i] + "Hidden";
    }
  }
  // otherwise it's not supported
  return null;
};
// ======================================================================================================
/**
 * Position de L'incident
 * @function
 * @name getCurrentIncidentTimeline
 * @param { number } currentTime
 * @param { number } duration
 * @return { any }
 */

export const getCurrentIncidentTimeline = (
  duration: number,
  currentTime: number
): any => {
  /**
   * @constant
   * @description : récuper l'identifiant du timeline
   * @name : seekTimeline
   */
  //  const seekTimeline =
  //  document.getElementById("seekCurrentIncident");
  /**
   * @constant
   * @description : récuper l'identifiant du timeline
   * @name : seekTimeline
   */
  const Timeline = document.getElementById("incidentTimelineVideo");

  if (Timeline !== null) {
    Timeline.addEventListener(
      "timeupdate",
      ({ target }: any) => {
        return target.currentTime / target.duration;
      },
      true
    );
  }
};
// ========================================================================================================
/**
 * lazy load
 * @function
 * @name brokenImage
 * @param { string } lazy
 * @return { any }
 */
export const brokenImage = (Image: string): boolean => {
  /**
   * @constant
   * @name Imageid
   * @description : faire appel au DOM
   * @type any
   */
  const Imageid: any = document.getElementById(Image);

  // vérification de l'existence de la variable
  if (Imageid !== null) {
    {
      /** vérification */
    }
    if (!Imageid.complete) {
      return false;
    }

    // However, they do have two very useful properties: naturalWidth and
    // naturalHeight. These give the true size of the image. If it failed
    // to load, either of these should be zero.
    if (
      typeof Imageid.naturalWidth !== "undefined" &&
      Imageid.naturalWidth === 0
    ) {
      return false;
    }

    // No other way of checking: assume it's ok.
    return true;
  } else {
    return false;
  }
};
// ========================================================================================================
/**
 * lazy load
 * @function
 * @name lazyLoad
 * @param { string } lazy
 * @return { any }
 */
export const getlazyLoad = (classname: string): void => {
  /**
   * @constant
   * @name lazy
   * @description : faire appel au DOM
   * @type any
   */
  const lazy: any = document.getElementsByClassName(classname);

  // boucle
  if (lazy !== null) {
    for (let i = 0; i < Math.ceil(lazy.length); i++) {
      // pre-chargment des images

      lazy[i].src = lazy[i].getAttribute("data-src"); //
    }
  }
};
// ========================================================================================================
/**
 * lazy load
 * @function
 * @name registerListener
 * @param { any } event
 * @param { any } func: la fonction a activé
 * @return { void }
 */
export const registerListener = (event: any, func: any): void => {
  //  évenément de l'objet window
  if (window.addEventListener) {
    // objet window
    window.addEventListener(event, func);
  }
};

// ========================================================================================================
/**
 * lazy load
 * @function
 * @description: Détruire l'event lié au DOM
 * @name removeRegisterListener
 * @param { any } event
 * @param { any } func: la fonction a activé
 * @return { void }
 */
export const removeRegisterListener = (event: any, func: any): void => {
  window.removeEventListener(event, func);

  //  évenément de l'objet window
  //   if (window.addEventListener) {
  //     // objet window
  //     window.removeEventListener(event, func)
  //   }
};

// ========================================================================================================

// ========================================================================================================
/**
 * lazy load
 * @function
 * @name zoomCenterMouse
 * @param { any } event
 * @return { void }
 */
export const zoomCenterMouse = (identifiant: string): void => {
  //  évenément de l'objet window
  if (window.addEventListener) {
    /**
     * @constant
     * @description :
     * @name  imageIncidentFile
     * @types any
     */
    const imageIncidentFile: any = document.querySelector(identifiant);

    // vérif la variable
    if (imageIncidentFile !== null) {
      window.addEventListener(
        "onwheel" in document ? "wheel" : "mousewheel",
        (event: any) => {
          // event.preventDefault();

          if (
            !Lodash.isUndefined(event.toElement) &&
            event.toElement.id === identifiant.replace("#", "")
          ) {
            // let xCoord: any = ""; // get mouse x coordonnates
            // let yCoord: any = ""; // get mouse y coordonnates;

            // // console.log(xCoord, yCoord);

            // if (event.pageX || event.pageY) {
            //   xCoord = Math.ceil(event.pageX - event.offsetX);
            //   yCoord = Math.ceil(event.pageY - event.offsetY);
            // } else {
            //   xCoord = Math.ceil(event.clientX - event.offsetX); // get x coordonnates
            //   yCoord = Math.ceil(event.clientY - event.offsetY); // get y coordonnates
            // }

            // definir le delta

            let delta: any = event.delta || event.wheelDelta;

            if (delta === undefined) {
              // nous sommes sur firefox
              delta = event.originalEvent.detail;
            }
          }
        }
      );
    }
  }
};

// ========================================================================================================
/**
 * lazy load
 * @function
 * @description: Détruire l'event lié au DOM
 * @name fullWidthContent
 * @param { any } event
 * @param { any } func: la fonction a activé
 * @return { void }
 */
export const fullWidthContent = (): number => {
  const fullWidth: any = document.querySelector("#fullWidthContent");

  let widthDocument: number = 0;

  if (fullWidth !== null) {
    widthDocument = fullWidth.offsetWidth;
  }
  return widthDocument;
};
// ========================================================================================================
/**
 * fetch data
 * @function
 * @description: Détruire l'event lié au DOM
 * @name fullWidthContent
 * @param { any } event
 * @param { any } func: la fonction a activé
 * @return { void }
 */
export async function fetchLogs(
  url: any,
  message: any,
  code: any,
  header: any
): Promise<any> {
  /**
   * Configuration dela viriable globale , L'objet window représente une
   * fenêtre contenant un document DOM
   */

  // const API_URL = 'env';
  // const pathDocument: string = window[API_URL].API_URL_LOG +"logs.txt";

  // let logs:any ;

  /*
      async function isDocumentFound(path: any) {
          try {
            const response = await fetch(path, {
              method: 'HEAD',
              cache: 'no-cache'
            });

            return response.status === 200;

          } catch(error) {

            return false;
          }
      }
      const isValidDocument =  await isDocumentFound(pathDocument); */
  const date: Date = new Date();

  return {
    type: "server error",
    message,
    code,
    header,
    url,
    date,
  };
  /*
      if(!isValidDocument && false){

          fs.open(pathDocument,"w+", (err, file) => {
              if (err) {throw err}
              else {fs.writeFile(file,logs, (errs)=>{throw errs})}

          })
      }else{
          fs.writeFile(pathDocument,logs, (errs)=>{throw errs})
      }*/
}
// ========================================================================================================
/**
 * fetch data
 * @function
 * @description: Détruire l'event lié au DOM
 * @name fullWidthContent
 * @param { any } event
 * @param { any } func: la fonction a activé
 * @return { void }
 */
export function fetchLogsFront(url: any, message: any): () => any {
  // const fs = require('fs')
  let logs: any;

  const date: Date = new Date();

  logs = {
    type: "front error",
    message,
    url,
    date,
  };

  return logs;
}



// WEBPACK FOOTER //
// ./src/Utils/helpers/index.ts